module.exports = __webpack_public_path__ + "static/media/still-life-1.679eb172.jpg";